import { useCallback, useEffect, useRef, useState } from 'react';

import { INTRO_ANIMATION_DURATION_MS } from '../lib/constants';

export const useIntroTransition = (goNext) => {
  const [isEnteringFromIntro, setIsEnteringFromIntro] = useState(false);
  const timeoutRef = useRef(null);

  const handleIntroNext = useCallback(() => {
    setIsEnteringFromIntro(true);
    goNext();

    timeoutRef.current = setTimeout(() => {
      setIsEnteringFromIntro(false);
    }, INTRO_ANIMATION_DURATION_MS);
  }, [goNext]);

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  return { isEnteringFromIntro, handleIntroNext };
};
